//routes to the dpd_map module
export const DPD_IFRAME_PATHS = {
    POINTS: '/dpd_map/points/',
    PACKMACHINE: '/dpd_map/packmachine/'
}//routes to the dpd_map module
export const DPD_IFRAME_PATHS = {
    POINTS: '/dpd_map/points/',
    PACKMACHINE: '/dpd_map/packmachine/'
}